import { Stack } from '@mui/material';
import { Frame } from '../../components/layouts/Frame';

export const Integrations = () => {
  return (
    <Frame title="Integrations">
      <Stack></Stack>
    </Frame>
  );
};
